<template>
  <div class="activity-info-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>淋浴记录</h2>
    </div>

    <!-- 查询表单 -->
    <el-form :inline="true" :model="queryForm" class="query-form">
      <el-form-item label="门店">
        <el-select
            v-model="queryForm.storeId"
            placeholder="选择店铺"
            clearable
            @change="handleQuery"
            filterable
        >
          <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="淋浴时间">
        <el-date-picker
            v-model="times"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">
          查询
        </el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">
          重置
        </el-button>
          <el-button
              type="primary"
              icon="el-icon-upload"
              @click="exportOrders"
              :loading="exporting"
          >导出Excel</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="activityList"
      border
      stripe
      height="700"
      style="width: 100%"
    >
      <el-table-column label="序号" width="80" align="center" type="index">
        <template slot-scope="scope">
          {{(queryForm.page - 1) * queryForm.limit + scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="storename" label="门店" align="center"/>
      <el-table-column prop="userName" label="使用用户" align="center"/>
      <el-table-column prop="Adddate" label="淋浴时间" align="center"/>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryForm.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { Loading } from "element-ui";
export default {
  name: 'ActivityInfo',
  data() {
    return {
      times: [],
      exporting: false,
      // 查询表单
      queryForm: {
        page: 1,
        limit: 10,
        storeId: '',
        startTime: null,
        endTime: null
      },
      // 活动列表
      activityList: [],
      storelist: [],
      // 总记录数
      total: 0,
      // 加载状态
      loading: false,
    }
  },
  created() {
    this.getActivityList()
    this.GetStore()
  },
  methods: {
    async GetStore() {
      const { data: res } = await this.$http.get("getNewStore");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    // 获取活动列表
    getActivityList() {
      this.loading = true
      const params = {
        page: this.queryForm.page,
        pageSize: this.queryForm.limit
      }

      // 添加可选查询参数
      if (this.queryForm.storeId) {
        params.storeId = this.queryForm.storeId
      }

      if (this.times.length > 0) {
        params.startTime = this.times[0]
        params.endTime = this.times[1]
      }

      // 使用 axios 发送请求
      this.$http.post('/getBathLog',  params)
        .then(response => {
          let data = response.data;
          if (data.code === 200) {
            this.activityList = data.data.list || []
            this.total = data.data.total || 0
          } else {
            this.$message.error(data.msg || '获取淋浴列表失败')
          }
        })
        .catch(error => {
          console.error('获取淋浴列表失败:', error)
          this.$message.error('获取淋浴列表失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 查询
    handleQuery() {
      this.queryForm.page = 1
      this.getActivityList()
    },

    // 重置
    handleReset() {
      this.queryForm = {
        page: 1,
        limit: 10,
        storeId: ''
      }
      this.getActivityList()
    },

    // 每页显示数量改变
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.queryForm.page = 1
      this.getActivityList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getActivityList()
    },

    // 导出订单数据
    exportOrders() {
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      if (this.times.length > 0) {
        this.queryForm.startTime = this.times[0]
        this.queryForm.endTime = this.times[1]
      }

      axios
          .get("/bathLogExport", {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            responseType: "blob",
            params: this.queryForm,
          })
          .then(async (data) => {
            const isBlob = data.data.type !== "application/json";
            if (isBlob) {
              const blob = new Blob([data.data]);
              saveAs(blob, `淋浴数据_${new Date().getTime()}.xlsx`);
            } else {
              this.$message.error("导出淋浴数据失败");
            }
            downloadLoadingInstance.close();
          })
          .catch((r) => {
            console.error(r);
            this.$message.error("下载文件出现错误，请联系管理员！");
            downloadLoadingInstance.close();
          });
    },
  }
}
</script>

<style scoped>
.activity-info-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.query-form {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  background: #fff;
}

.dialog-footer {
  text-align: right;
}
</style>
